module.exports = __webpack_public_path__ + "static/media/IMG_0103.1a566e87.JPG";